import ProjectsHolder from './ProjectsHolder';
import YearSelect2 from './YearSelect2';
import { useOutletContext } from "react-router";

export default function Projects() {
    let { projects } = useOutletContext();
    projects = projects.map(project=>({...project, Year:Number(project.Date.substring(0,4))}));

    return (
        <div id="projcontainer">
            <YearSelect2
                projects={projects}
            />
            <ProjectsHolder
                projects={projects}
            />
        </div>
    )
}